import React, { useState } from "react";
import Header from "../../../Components/Header";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import PendingApprovals from "./PendingApprovals";
import CheckerMyRequests from "./CheckerMyRequests";

function DealerMapCheckerTabs(props) {
const [activeTab, setActiveTab] = useState("pendingApp");

    return (
        <div className="dealer-mapping-main">
            <Header title={props.title} portal={""} />
            <SingleSignOnSideBar />
            <main id="dealermap-main-content">
                <div className="tab-content card-box cl-mapping-tab" id="mainTabContent">
                    <div
                        className="tab-pane fade show active"
                        id="team"
                        role="tabpanel"
                        aria-labelledby="team-tab"
                    > 
                        <div className="secondary-tabs">
                            <div className="card-tab-list">
                                <ul className="nav page-tabs" id="mainTab">
                                    <li className="nav-item">
                                        <button 
                                            className={`nav-link ${activeTab === "pendingApp" ? "active" : ""}`}
                                            id="pendingApp-tab"
                                            data-toggle="tab"
                                            data-target="#pendingApp"
                                            type="button"
                                            role="tab"
                                            aria-controls="pendingApp"
                                            aria-selected="true"
                                            onClick={() => setActiveTab("pendingApp")}
                                        >
                                            Pending Approvals
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            // className="nav-link"
                                            className={`nav-link ${activeTab === "myReq" ? "active" : ""}`}
                                            id="myReq-tab"
                                            data-toggle="tab"
                                            data-target="#myReq"
                                            type="button"
                                            role="tab"
                                            aria-controls="myReq"
                                            aria-selected="false"
                                            onClick={() => setActiveTab("myReq")}
                                        >
                                            My Requests
                                        </button>
                                    </li>
                                </ul>
                            </div>

                            <div className="card-tab-details">
                                <div
                                    className="tab-content dashboard-tab-content"
                                    id="nav-tabContent"
                                >
                                       
                                        {activeTab === "pendingApp" && (
                                            <PendingApprovals setActiveTab={setActiveTab} />
                                        )}
                                         {activeTab === "myReq" && (
                                            <CheckerMyRequests setActiveTab={setActiveTab} />
                                         )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default DealerMapCheckerTabs;
